import { differenceInCalendarDays, differenceInDays, differenceInHours, differenceInMinutes, differenceInMonths, differenceInWeeks, format, startOfWeek, WeekOptions } from "date-fns";

const weekOptions: WeekOptions = {
  weekStartsOn: 1,
};

export default function (now: Date, date: Date) {
  const months = differenceInMonths(date, now);
  if (months > 1) {
    return `in ${months} months`;
  } else if (months === 1) {
    return "in a month";
  }

  const weeks = differenceInWeeks(date, now);
  if (weeks > 1) {
    return `in ${weeks} weeks`;
  } else if (weeks === 1) {
    return "in a week";
  }

  const calendarDays = differenceInCalendarDays(date, now);
  if (calendarDays === 1) {
    return `tomorrow at ${format(date, date.getMinutes() > 0 ? "h:mmaaa" : "haaa")}`;
  }

  const days = differenceInDays(date, now);
  if (days > 1) {
    const targetDay = format(date, "EEEE");
    const nowWeekStart = startOfWeek(now, weekOptions);
    const dateWeekStart = startOfWeek(date, weekOptions);
    const isNextWeek = dateWeekStart.getTime() > nowWeekStart.getTime();

    return isNextWeek ? `next ${targetDay}` : `on ${targetDay}`;
  }

  const hours = differenceInHours(date, now);
  if (hours > 1) {
    return `in ${hours} hours`;
  } else if (hours === 1) {
    return "in 1 hour";
  }

  const minutes = differenceInMinutes(date, now);
  if (minutes > 1) {
    return `in ${minutes} minutes`;
  } else if (minutes === 1) {
    return "in 1 minute";
  }

  return "in less than a minute";
}
